import React, { useEffect } from 'react';
import LoadingAnimation from 'components/UI/Loader';
import { useSelector } from 'react-redux';

const BriefingTable = ({ headers, rows, renderRow, createRow = null, tableClass = "briefing-table top-section" }) => {
    const briefing = useSelector((state) => state.briefing.line);
    return (
        <div>
            <table className={tableClass}>
                <thead>
                    <tr>
                        {headers.map((header, index) => (
                            <th key={index}>{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.length > 0 ? (
                        rows.map((row, index) => (
                            renderRow(row)
                        ))
                    ) : (
                        <tr>
                            <td colSpan={headers.length}>
                                {/* <LoadingAnimation /> */}
                            </td>
                        </tr>
                    )}
                    {briefing === "Briefings" && createRow ? (
                        <tr>
                            <td colSpan={headers.length}>
                                <button className="new-row-btn" onClick={() => createRow()}>
                                    <div className="sign">+</div>
                                    <div className="text">Insert New Row</div>
                                </button>
                            </td>
                        </tr>
                    ) : (null)
                    }
                </tbody>
            </table>
        </div>
    );
};

export default BriefingTable;
